import { create } from 'zustand';

interface UIState {
  paletteOpen: boolean;
  togglePalette: () => void;
  setPaletteOpen: (open: boolean) => void;

  activityOpen: boolean;
  toggleActivity: () => void;
  setActivityOpen: (open: boolean) => void;

  /** Mobile sidebar drawer (off-canvas) */
  navOpen: boolean;
  toggleNav: () => void;
  setNavOpen: (open: boolean) => void;
}

export const useUI = create<UIState>(set => ({
  paletteOpen: false,
  togglePalette: () => set(s => ({ paletteOpen: !s.paletteOpen })),
  setPaletteOpen: open => set({ paletteOpen: open }),

  activityOpen: false,
  toggleActivity: () => set(s => ({ activityOpen: !s.activityOpen })),
  setActivityOpen: open => set({ activityOpen: open }),

  navOpen: false,
  toggleNav: () => set(s => ({ navOpen: !s.navOpen })),
  setNavOpen: open => set({ navOpen: open }),
}));
